import { combineReducers } from 'redux';
import cartReducer from './cart/cartSlice';
import merchantReducer from './merchant/reducer';


export default combineReducers({
    cart: cartReducer,
    merchant: merchantReducer
});